<script>
import appConfig from '@src/app.config';
import Layout from '@layouts/main';
import { videoEpisode, formatTime, isInQueue } from '@/src/utils/utils';
import { translationMethods, jobMethods } from '@state/helpers'
import { showToast } from '@/src/utils/notifications';

export default {
  page: {
    title: 'Render Queue',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: { Layout },

  data() {
    return {
      jobs: [],
      user: this.$store ? this.$store.state.auth.user : {} || {},
    };
  },

  created() {
    window.jq = this;
    this.getJobs();

    if(this.jobInterval) clearInterval(this.jobInterval);
    this.jobInterval = setInterval(() => this.getJobs(), 30000);
  },

  destoyed: function() {
    clearInterval(this.jobInterval)
  },

  methods: {
    videoEpisode,

    formatTime,

    async getJobs() {
      this.jobs = await this.getJobsInQueue();

      $('#job-list')
        .sortable({
          items:".sortable-job",
          distance: 10,
          placeholder: "job-placeholder",
          forcePlaceholderSize: !0,
          opacity:.5,
          cursor:"move",
          start: function(e, ui){
            ui.placeholder.height(ui.item.outerHeight());
          },          
          update: (e, ui) => {
            const jobId = ui.item.attr('id').split('-')[1];
            const oldIndex = this.jobs.findIndex(job => job.id == jobId);
            const newIndex = ui.item.index();
            console.log(jobId, oldIndex, newIndex);
            
            this.reorder(jobId, oldIndex > newIndex ? 'up' : 'down', Math.abs(oldIndex - newIndex));
          }
        })
    },

    getStep(job) {
      switch(job.status) {
        case 'CREATING':
          return 'Queued';
        case 'DOWNLOADING':
          return '1 of 5';
        case 'UNZIPPING':
          return '2 of 5';
        case 'ENCODING':
          return '3 of 5';
        case 'UPLOADING':
          return '4 of 5';
        case 'DONE':
          return 'Done';
        case 'ERROR':
          return 'Error';
      }
    },

    getProgress(job) {
      if(job.status === 'ENCODING') {
        return `Rendering ${job.progress}%`;
      }
    },

    async reorder(id, direction, amount) {
      const succeeded = await this.reorderJob({ id, direction, amount });

      if(succeeded) {
        showToast('Updated Queue', '', 'success');
      } else {
        // showToast('Unable to Update Queue', '', 'danger');
      }

      this.getJobs();
    },

    async increasePriority(jobId) {
      const index = this.jobs
        .filter(isInQueue)
        .findIndex(job => job.id == jobId);

      await this.reorder(jobId, 'up', index);
    },

    async deleteJobInQueue(job) {
      if(!confirm('Are you sure you want to delete this job? This cannot be undone.')) {
        return;
      }

      await this.deleteJob(job.id);

      showToast('Job Deleted', '', 'success');

      this.getJobs();
    },

    isInQueue: isInQueue,

    jobEntity(job) {
      return job.translation || job.customization;
    },

    jobVideo(job) {
      return this.jobEntity(job).video;
    },

    jobLanguage(job) {
      return job.translation
        ? job.translation.language
        : (job.customization ? job.customization.customization_template.language : null);
    },

    jobName(job) {
      return job.translation
        ? job.translation.video.name
        : (job.customization ? job.customization.name : null);
    },


    ...translationMethods,
    ...jobMethods,
  },
}
</script>

<template>
  <Layout>
    <h4 class="mb-4 mt-4">Render Queue</h4>
    <div id="job-list">
      <div v-for="job of jobs"
        :id="'job-' + job.id"
        :key="job.id"
        class="job card-box"
        :class="{ 'sortable-job': isInQueue(job) }">
        <div class="dropdown float-right">
          <b-dropdown size="sm" right variant="link" no-caret boundary="window">
            <template v-slot:button-content>
              <i class="card-drop icon-link mdi mdi-dots-vertical"></i>
            </template>
            <b-dropdown-item v-if="isInQueue(job) && user.permissions.includes('edit.videos') && job.status === 'CREATING'"
              @click="increasePriority(job.id)">
              <span class="text-info">
                <i class="mdi mdi-arrow-up-bold-outline mr-1"></i>
                Move to top
              </span>
            </b-dropdown-item>
            <b-dropdown-item v-if="user.permissions.includes('edit.videos')"
              @click="deleteJobInQueue(job)">
              <span class="text-danger">
                <i class="mdi mdi-delete mr-1"></i>
                Delete
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="content">
          <div class="language">
            <div class="badge bg-primary">{{ jobLanguage(job) }}</div>
          </div>
          <div class="info">
            <div>
              <router-link
                tag="a"
                :to="`/job/${job.id}`">
                <span class="title">{{ jobName(job) }}</span>
              </router-link>
              &nbsp;
              <span class="course">
                <router-link
                  v-if="jobVideo(job).course"
                  tag="a"
                  :to="`/videos/?course=${jobVideo(job).course_id}`">
                  <span class="text-capitalize">{{ jobVideo(job).course }}</span>
                </router-link>
                <span v-if="jobVideo(job).course">&nbsp;•&nbsp;</span>
                <router-link
                  tag="a"
                  :to="user.permissions.includes('edit.videos') ? `/video/${jobVideo(job).id}` : '/'">
                  <span class="text-capitalize">{{ videoEpisode(jobVideo(job)) }}</span>
                </router-link>
              </span>
            </div>
            <div>
              Submitted on {{ formatTime(job.created_at) }}
            </div>
          </div>
          <div class="status">
            {{ getStep(job) }} <strong> {{ getProgress(job) }}</strong>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
  .job-placeholder {
    border: 2px dashed rgba(50,58,70,.4);
    min-height: 92px;
    margin-bottom: 24px;
  }

  .job .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    
    .language {
      text-transform: capitalize;
      min-width: 65px;
    }

    .info {
      flex-grow: 1;
      flex-shrink: 1;

      .title {
        font-size: 17px;
        font-weight: 700;
        line-height: 19px
      }

      .course {
        font-size: 17px;
        line-height: 21px
      }
    }

    .status {
      width: 150px;
    }

  }
</style>
